import { createSelector } from 'reselect';

const selectGlobalDBNAgentMapping = (state: any) => state.globalDBNAgentMapping;


export const selectGlobalDBNAgentMappingCurrentItem = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.current);

export const selectGlobalDBNAgentMappingListItems = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDBNAgentMappingListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDBNAgentMappingQueryItems = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.query);

export const selectGlobalDBNAgentMappingCreatedItem = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.create);

export const selectGlobalDBNAgentMappingUpdatedItem = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.update);

export const selectGlobalDBNAgentMappingReadItem = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.read);

export const selectGlobalDBNAgentMappingDeletedItem = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.delete);

export const selectGlobalDBNAgentMappingSearchedItems = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.search);

export const selectGlobalDBNAgentMappingItemsCount = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.count);

export const selectGlobalDBNAgentMappingItemsFilter = createSelector([selectGlobalDBNAgentMapping], (globalDBNAgentMapping) => globalDBNAgentMapping.filter);